<script>
import useSharedData from "@/use/SharedData";
import useTools from "@/use/Tools";
import {useSecurityStore} from "@/stores/Security";
import {onMounted, ref} from "vue";
import axios from "axios";
import {useImportModelStore} from "@/stores/ImportModel";

export default {
    setup() {
        const {$i18n, $router} = useTools();

        const {
            loading,
            total,
        } = useSharedData();

        const securityStore = useSecurityStore();
        const importModelStore = useImportModelStore();

        const search = ref(null);

        const headers = ref([
            {
                text: "...",
                align: "start",
                sortable: false,
                value: "action",
                width: "0%"
            },
            {
                text: $i18n.t("common.label"),
                align: "start",
                sortable: true,
                value: "name",
            },
            {
                text: $i18n.t("common.comment"),
                align: "start",
                sortable: true,
                value: "description",
            },
        ]);

        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_PAY_SLIP_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'import_models.edit', params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: () => securityStore.authorities['UPDATE_PAY_SLIP_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'import_models.delete', params: {id: item.id}})
                },
            },
        ];

        function findAll() {
            loading.value = true;
            axios.get('/importModels').then((response) => {
                importModelStore.setImportModels(response.data);
                total.value = response.data.length;
            }).finally(() => {
                loading.value = false;
            });
        }

        function view(item) {
            $router.push({name: "import_models.view", params: {id: item.id}});
        }

        onMounted(() => findAll());

        return {
            importModelStore,
            securityStore,
            search,
            loading,
            total,
            headers,
            actions,
            findAll,
            view
        }
    }
};
</script>

<template>
    <div>
        <w-app
            :title="$t('module.import_models')"
            :total="total"
        >
            <template v-slot:rightToolbar>
                <w-btn-reload
                    :loading="loading"
                    @press="findAll"
                />
                <w-btn-add
                    :show="securityStore.authorities['UPDATE_PAY_SLIP_PARAM']"
                    @press="$router.push({ name: 'import_models.add' })"
                />
            </template>

            <template v-slot:content>
                <w-data-table
                    :headers="headers"
                    :actions="actions"
                    :search="search"
                    :items="importModelStore.importModels"
                    :total="total"
                    :loading="loading"
                    sort-by="name"
                    @rowDbClick="view"
                >
                    <template v-slot:[`item.name`]="{ item }">
                        <w-inline-text bold :text="item.name"/>
                    </template>
                </w-data-table>
            </template>
        </w-app>
        <router-view/>
    </div>
</template>
